import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-blueDeep py-12 text-brand-cream" data-id="element-104" data-mp="3ggaqtvj9sd5g">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-105" data-mp="32ovwisjwwpj3">
        <div className="mb-8 rounded-2xl border border-white/10 bg-white/5 p-6 text-sm leading-relaxed" data-id="element-106" data-mp="36p6aardy4k8i">
          <p data-id="element-107" data-mp="3ueiltxwqx4dz">
            <strong className="text-brand-goldLight" data-id="element-108" data-mp="3ug3f7k7bqha9">P.D.:</strong> Si tenés dudas, escribinos a{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-109" data-mp="37o56rpk5rbs">
              {SUPPORT_EMAIL}
            </a>{' '}
            o por{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={WHATSAPP_LINK} data-id="element-110" data-mp="3qcx9cdo4is4b">
              WhatsApp
            </a>
            . También podés encontrarnos en Instagram como{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={INSTAGRAM_LINK} data-id="element-111" data-mp="2eyt94pqy07qt">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="mt-3 italic text-brand-cream/75" data-id="element-112" data-mp="3gapdlka06mgi">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu sistema profesional de
            Biodescodificación es ahora.
          </p>
        </div>

        <div className="mb-10 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-113" data-mp="3q7llpovzp6kj">
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-114" data-mp="81pddd69wn6q">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={INSTAGRAM_LINK} data-id="element-115" data-mp="hsabkzi1bpp4">
            📲 @lumen.akasha
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href="https://www.lumenakasha.com" data-id="element-116" data-mp="qt8fziwdxz88">
            🌐 www.lumenakasha.com
          </a>
        </div>

        <div className="mb-8" data-id="element-117" data-mp="tvw8wk94jlhk">
          <h3 className="mb-2 font-display text-3xl font-bold text-brand-goldLight" data-id="element-118" data-mp="twxv9kvlbuel">LUMEN AKASHA™</h3>
          <p className="text-brand-cream/80" data-id="element-119" data-mp="yuh6ebwzrr2b">
            Recursos digitales educativos para terapeutas y facilitadores de Biodescodificación.
          </p>
          <p className="mt-2 text-brand-cream/70" data-id="element-120" data-mp="18k94hg4av2bj">
            Herramientas educativas creadas para aportar mayor organización, claridad y estructura a tu práctica.
          </p>
        </div>

        <div className="space-y-2 border-t border-white/10 pt-6 text-xs text-brand-cream/50" data-id="element-121" data-mp="1hk5wnrpwejbc">
          <p data-id="element-122" data-mp="1mj8uos7gnp9t">
            © Lumen Akasha™ 2025 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p data-id="element-123" data-mp="1rgiosl5sop3z">
            Ley 25.326 — Protección de Datos Personales — República Argentina · Ley 11.723 — Propiedad Intelectual —
            República Argentina
          </p>
        </div>
      </div>
    </footer>;
}